import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import classNames from 'classnames';
var measurements = {
  microgram: 'mcg',
  milligram: 'mg',
  gram: 'g'
};

var Nutrient = function Nutrient(_ref) {
  var label = _ref.label,
      value = _ref.value,
      percent = _ref.percent,
      measurement = _ref.measurement,
      isStrongPercent = _ref.isStrongPercent,
      className = _ref.className;
  var hasValue = typeof value !== 'undefined' && value !== null;
  var hasPercent = typeof percent !== 'undefined' && percent !== null;
  return hasValue || hasPercent ? /*#__PURE__*/React.createElement("div", {
    className: "nutrition-facts__nutrient d-flex justify-content-between " + className
  }, /*#__PURE__*/React.createElement("span", null, label, " " + (hasValue ? value + measurement : '')), hasPercent && (isStrongPercent ? /*#__PURE__*/React.createElement("strong", null, percent, "%") : /*#__PURE__*/React.createElement("span", null, percent, "%"))) : null;
};

var NutritionFacts = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NutritionFacts, _React$Component);

  function NutritionFacts() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NutritionFacts.prototype;

  _proto.render = function render() {
    var _classNames;

    var nutritionClass = classNames('nutrition-facts', (_classNames = {}, _classNames["" + this.props.className] = this.props.className, _classNames));
    return /*#__PURE__*/React.createElement("section", {
      className: nutritionClass
    }, /*#__PURE__*/React.createElement("div", {
      className: "nutrition-facts__panel"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "nutrition-facts__title nutrition-facts__text--large nutrition-facts__border--bottom m-0"
    }, /*#__PURE__*/React.createElement("strong", null, "Nutrition Facts")), /*#__PURE__*/React.createElement("div", {
      className: "py-1"
    }, this.props.servings && /*#__PURE__*/React.createElement("span", null, this.props.servings, " servings per container"), this.props.servingSize && /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between"
    }, /*#__PURE__*/React.createElement("strong", null, "Serving Size"), /*#__PURE__*/React.createElement("strong", null, this.props.servingSize))), /*#__PURE__*/React.createElement("hr", {
      className: "nutrition-facts__border--top nutrition-facts__border--thicker m-0"
    }), this.props.calories && /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between m-0 py-1 nutrition-facts__border--bottom nutrition-facts__border--thick"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Amount per serving"), /*#__PURE__*/React.createElement("h4", {
      className: "m-0"
    }, /*#__PURE__*/React.createElement("strong", null, "Calories"))), /*#__PURE__*/React.createElement("strong", {
      className: "nutrition-facts__calorie-value nutrition-facts__text--large align-self-end"
    }, this.props.calories)), /*#__PURE__*/React.createElement("div", {
      className: "nutrition-facts__nutrients"
    }, /*#__PURE__*/React.createElement("div", {
      className: "border-top-md d-flex justify-content-end"
    }, /*#__PURE__*/React.createElement("strong", null, "% Daily Value*")), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("strong", null, "Total Fat"),
      value: this.props.totalFat,
      percent: this.props.totalFatPercent,
      measurement: measurements.gram,
      isStrongPercent: true,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "ml-3"
      }, "Saturated Fat"),
      value: this.props.satFat,
      percent: this.props.satFatPercent,
      measurement: measurements.gram,
      isStrongPercent: true,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "ml-3"
      }, /*#__PURE__*/React.createElement("em", null, "Trans"), " Fat"),
      value: this.props.transFat,
      measurement: measurements.gram,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "ml-3"
      }, "Polyunsaturated Fat"),
      value: this.props.polyUnsatFat,
      measurement: measurements.gram,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "ml-3"
      }, "Monounsaturated Fat"),
      value: this.props.monoUnsatFat,
      measurement: measurements.gram,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("strong", null, "Cholesterol"),
      value: this.props.cholesterol,
      percent: this.props.cholesterolPercent,
      measurement: measurements.milligram,
      isStrongPercent: true,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("strong", null, "Sodium"),
      value: this.props.sodium,
      percent: this.props.sodiumPercent,
      measurement: measurements.milligram,
      isStrongPercent: true,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("strong", null, "Total Carbohydrate"),
      value: this.props.carbohydrate,
      percent: this.props.carbohydratePercent,
      measurement: measurements.gram,
      isStrongPercent: true,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "ml-3"
      }, "Dietary Fiber"),
      value: this.props.dietaryFiber,
      percent: this.props.dietaryFiberPercent,
      measurement: measurements.gram,
      isStrongPercent: true,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("span", {
        className: "ml-3"
      }, "Total Sugars"),
      value: this.props.totalSugars,
      measurement: measurements.gram,
      className: "nutrition-facts__border--top"
    }), typeof this.props.addedSugars !== 'undefined' && /*#__PURE__*/React.createElement("div", {
      className: "ml-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "nutrition-facts__border--top d-flex justify-content-between ml-3"
    }, /*#__PURE__*/React.createElement("span", null, "Includes ", this.props.addedSugars, measurements.gram, " Added Sugars"), typeof this.props.addedSugarsPercent !== 'undefined' && /*#__PURE__*/React.createElement("strong", null, this.props.addedSugarsPercent, "%"))), /*#__PURE__*/React.createElement(Nutrient, {
      label: /*#__PURE__*/React.createElement("strong", null, "Protein"),
      value: this.props.protein,
      measurement: measurements.gram,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement("div", {
      className: "nutrition-facts__vitMin nutrition-facts__border--top nutrition-facts__border--thicker"
    }, /*#__PURE__*/React.createElement(Nutrient, {
      label: "Vitamin D",
      value: this.props.vitaminD,
      percent: this.props.vitaminDPercent,
      measurement: measurements.microgram
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: "Vitamin A",
      value: this.props.vitaminA,
      percent: this.props.vitaminAPercent,
      measurement: measurements.microgram,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: "Vitamin C",
      value: this.props.vitaminC,
      percent: this.props.vitaminCPercent,
      measurement: measurements.microgram,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: "Calcium",
      value: this.props.calcium,
      percent: this.props.calciumPercent,
      measurement: measurements.milligram,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: "Iron",
      value: this.props.iron,
      percent: this.props.ironPercent,
      measurement: measurements.milligram,
      className: "nutrition-facts__border--top"
    }), /*#__PURE__*/React.createElement(Nutrient, {
      label: "Potassium",
      value: this.props.potassium,
      percent: this.props.potassiumPercent,
      measurement: measurements.milligram,
      className: "nutrition-facts__border--top"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "nutrition-facts__border--top pt-1 small nutrition-facts__border--thick"
    }, "* The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories a day is used for general nutrition advice.")));
  };

  return NutritionFacts;
}(React.Component);

export { NutritionFacts as default };